import * as React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav
} from 'reactstrap';
import logo from '../../../images/GMCNgine-Horizontal2x.png';
import './navbar.css';
import { useNavState } from './hooks/useNavState';
import MobileView from './components/MobileView';
import DesktopView from './components/DesktopView';
import { useCurrentRoute } from 'src/modules/Routing/auth/useCurrentRoute';

export interface INavBarState {
  isMobile: boolean
};

export interface INavBarProps {
}

const NavBar: React.SFC<INavBarProps> = (props) => {
  const [state, actions] = useNavState();
  const [currentRoute] = useCurrentRoute();
  return currentRoute.showNavBar ? (
    <div>
      <Navbar color="#0092a0" light={true} expand="md">
        <NavbarBrand href="/">
          <img src={logo} alt="ICMEC" className="nav-bar-logo" />
        </NavbarBrand>
        <NavbarToggler onClick={actions.toggle} />
        <Collapse isOpen={state.isOpen} navbar={true}>
          <Nav className="ml-auto" navbar={true}>
            {state.isMobile ?
              <MobileView
                actions={actions}
                isOpenMenuItem={state.isOpenMenuItem}
              /> :
              <DesktopView
                actions={actions}
                toggleSettings={state.toggleSettings}
              />}
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  ) : null
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/modules/Navigation/NavBar/NavBar.tsx